import React from 'react';

import colors from 'config/theme/colors';
import styled from 'libs/styled';
import { useSelector } from 'react-redux';
import zIndex from 'config/theme/z-index';

const Wrapper = styled('div')`
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: ${zIndex.forground};
    padding: 8px 16px;
    background-color: ${colors.black};
    color: ${colors.white};
    font-size: 14px;
    line-height: 1.4;
    text-align: center;
`;

/**
 * Tells editors that the page they are looking at is a preview of unpublished content.
 * Only rendered when the API resolved the page with a valid preview token.
 */
const PreviewBanner = () => {
    const isPreview = useSelector(state => state.page.isPreview);

    if (!isPreview) {
        return null;
    }

    return <Wrapper>Preview: this is unpublished content and is not visible to visitors.</Wrapper>;
};

export default PreviewBanner;
